<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>学生单词本</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="80" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="学生ID：">
              <Input v-model="queryParam.studentId" placeholder="学生ID" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="姓名：">
              <Input v-model="queryParam.username" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="手机号：">
              <Input v-model="queryParam.mobile" placeholder="手机号" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <FormItem label="单词：">
              <Input v-model="queryParam.word" placeholder="支持模糊搜索" clearable></Input>
            </FormItem>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Button type="primary" :loading="searchLoading" icon="search" @click="search">搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>

    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/studentWordbook/list"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>
<script>
export default {
  data () {
    return {
      searchLoading: false,
      reload: 0,
      queryParam: {
        studentId: '',
        username: '',
        mobile: '',
        word: ''
      },
      title: [
        {title: '学生ID', width: 100, key: 'studentId'},
        {title: '姓名', minWidth: 100, key: 'username'},
        {
          title: '手机号',
          width: 130,
          render: (h, params) => this.renderMobile(h, params.row.mobile)
        },
        {
          title: '单词',
          minWidth: 120,
          render: (h, params) => {
            let row = params.row
            return h('span', row.displayWord || row.word || '')
          }
        },
        {title: '音标', minWidth: 120, key: 'usPhonetic'},
        {
          title: '释义',
          minWidth: 180,
          render: (h, params) => {
            let text = params.row.explains || ''
            return h('div', {
              attrs: {title: text},
              style: {
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap'
              }
            }, text)
          }
        },
        {title: '跟读次数', width: 100, key: 'evalCount'},
        {title: '平均分', width: 90, key: 'avgScore'},
        {title: '最近得分', width: 90, key: 'lastScore'},
        {
          title: '最近录音',
          minWidth: 200,
          render: (h, params) => {
            let url = params.row.lastAudioUrl
            if (!url) {
              return h('span', '')
            }
            return h('audio', {
              attrs: {src: url, controls: 'controls', preload: 'none'},
              style: {width: '180px', height: '32px'}
            })
          }
        },
        {title: '收藏时间', minWidth: 160, key: 'gmtModified'}
      ]
    }
  },
  methods: {
    renderMobile (h, mobile) {
      if (!mobile || (typeof mobile === 'string' && mobile.startsWith('n'))) {
        return h('span', '')
      }
      let display = String(mobile).length === 11
        ? String(mobile).substring(0, 3) + '****' + String(mobile).substring(7)
        : mobile
      return h('Poptip', {
        props: {trigger: 'hover'}
      }, [
        h('span', {}, display),
        h('div', {slot: 'content'}, mobile)
      ])
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
    }
  }
}
</script>



// WEBPACK FOOTER //
// StudentWordbookList.vue?c0fa5054